/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { Button, Icon } from 'semantic-ui-react'
import React from 'react'
import { useTranslation } from 'react-i18next'

const ItemsAwaitingActionButton = ({ orderItemListRef, orderItems }) => {
    const [t] = useTranslation()

    return (
      <Button
        icon
        fluid
        color="yellow"
        css={css`
            &.ui.button {
                display: flex;
                justify-content: space-between;
            }
        `}
        onClick={() => {
            const orderItem = orderItems.find(item => item.customerAckType === 'AWAITING_ACTION')
            if (!orderItemListRef.current) {
                return
            }

            const orderItemElement = Array.from(orderItemListRef.current.children)
              .find(item => item.id === `orderItem-${orderItem.id}`)

            if (orderItemElement) {
                orderItemElement.scrollIntoView({behavior: 'smooth', block: 'center'})
            }
        }}
      >
          <Icon name="arrow down"/>
            {t('order.detail.items_awaiting_customer_action')}
          <Icon name="arrow down"/>
      </Button>
    )
}

export { ItemsAwaitingActionButton }
